<template>
  <div style="background: #f9f9f9; padding-bottom: 80px" class="adaptiveMobileNewClass">
    <div class="new_top_nap">
      <span>当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/park' }">泵都风采</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/parkDynamic' }">泵都资讯</el-breadcrumb-item>
        <el-breadcrumb-item >{{ detail.programName }}</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>{{ detail.parkName }}</el-breadcrumb-item> -->
      </el-breadcrumb>
    </div>
    <div class="new_con" v-loading="loading">
      <h2>
        {{ detail.title }}
      </h2>
      <div class="flex new_con_box">
        <div class="new_con_left flex" style="margin-top: 14px;">
          <p>来源：{{ detail.source }}</p>
          <p>发布时间：{{ detail.createDate }}</p>
          <p class="flex">
            <i class="iconfont">&#xe611;</i>
            <span> {{ detail.pageViews }} </span>
          </p>
        </div>
        <div class="new_con_right flex">
          <p class="flex">
            <i v-if=detail.isCollection class="el-icon-star-on"
               style="margin-right: 8px;color: #E6A23C;cursor: pointer;font-size: 24px;" @click="deleteCollectionNews"></i>
            <i v-if=!detail.isCollection class="el-icon-star-off"
               style="margin-right: 8px;cursor: pointer;font-size: 20px;" @click="collectionNews"></i>
            <span> {{ detail.collectionsNum }}</span>
          </p>
          <i class="new_icon"></i>
          <p class="flex">
            <i v-if=detail.isLike class="iconfont" style="margin-right: 8px;color: #E6A23C;cursor: pointer;"
               @click="deleteNewsFabulous">&#xe665;</i>
            <i v-if=!detail.isLike class="iconfont" style="margin-right: 8px;cursor: pointer;"
               @click="saveNewsFabulous">&#xe665;</i>
            <span> {{ detail.likesNum }} </span>
          </p>
          <i class="new_icon"></i>
          <share :config="config" style="z-index: 99999999;"></share>
        </div>
      </div>
      <div class="new_con_mess">
        <p class="editorStyleDetailContent vHtmlMess" v-html="detail.content"></p>
      </div>
      <div class="flex new_bottom">
        <div class="new_bottom_left" @click="goToDetail(detailData.before)">
          <p
              class="flex"
              v-if="detailData.before != null"

          >
            <i></i> 上一篇
          </p>
          <p v-if="detailData.before != null">{{ detailData.before.title }}</p>
        </div>
        <div class="new_bottom_right" @click="goToDetail(detailData.after)">
          <p
              v-if="detailData.after != null"

          >
            下一篇 <i></i>
          </p>
          <p v-if="detailData.after != null">{{ detailData.after.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deleteNewsCollection,
  deleteNewsFabulous,
  getNewcurrent,
  getNewsItemInfo,
  saveNewsCollection,
  saveNewsFabulous
} from "../../utils/interface";
import {mapState} from "vuex";
import QRCode from "qrcodejs2";


export default {
  //   新闻
  name: "news",
  components: {},

  data() {
    return {
      config: {
        url: window.location.href,
        disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo'],
      },
      uuid: "", //主键
      origin: "PARK", //来源
      parkUuid: "", //园区主键
      detailData: [],
      detail: {},
      userDetail: {},
      setIn: null,
      linkUrl: "",
    };
  },
  created() {
    this.uuid = this.$route.params.uuid;
    this.linkUrl = window.location.href;
    console.log(this.linkUrl)
    this.getNewcurrent();
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getNewsItemInfo();
      }
    }, 500);
  },
  mounted() {
    window.scrollTo(0, 0);
    this.creatQrCode();
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  methods: {
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: window.location.href, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    getNewsItemInfo() {
      let params = {
        uuid: this.uuid,
        origin: this.origin,
        parkUuid: this.parkUuid,
      };
      if (this.$store.state.isLogin) {
        params.userId = this.userDetail.uuid;
      }
      getNewsItemInfo(params).then((res) => {
        window.scrollTo(0, 0);

        if (res.success) {
          this.detailData = res.data;
          this.detail = res.data.current;
          this.config.title = res.data.current.title;
          this.config.description = res.data.current.summary;
          this.config.image = res.data.current.pictureUrl;

        }
      });
    },
    getNewcurrent() {
      if (!this.$store.state.isLogin) {
        return;
      }
      getNewcurrent().then((res) => {
        this.userDetail = res;
      })
    },

    saveNewsFabulous() {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.detail.uuid,
        userId: this.userDetail.uuid,
      }
      saveNewsFabulous(param).then((response) => {
        this.getNewsItemInfo();
      })
    },
    deleteNewsFabulous() {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.detail.uuid,
        userId: this.userDetail.uuid,
      }
      deleteNewsFabulous(param).then((response) => {
        this.getNewsItemInfo();
      })
    },
    collectionNews() {
      if (!this.$store.state.isLogin) {
        // this.$message.error("用户未登陆")
        // return false;
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.detail.uuid,
        userId: this.userDetail.uuid,
      }
      saveNewsCollection(param).then((response) => {
        this.getNewsItemInfo();
      })
    },
    deleteCollectionNews() {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      }
      let param = {
        newsUuid: this.detail.uuid,
        userId: this.userDetail.uuid,
      }
      deleteNewsCollection(param).then((response) => {
        this.getNewsItemInfo();
      })
    },
    goToDetail(info) {
      this.uuid = info.uuid;
      this.getNewsItemInfo();
    },
  },
};
</script>
<style src="../../assets/dist/css/share.min.css"></style>
<style scoped lang="less">
@import "../../assets/dist/css/share.min.css";

.blue {
  color: #009999;
}

.red {
  color: #d60000;
}

.soluBanner {
  position: relative;
  width: 100%;

  img {
    width: 100%;
    display: block;
  }

  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;

    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }

    .soluBanText {
      // margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }

      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }
}

.new_top_nap {
  font-size: 14px;
  color: #808080;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;

  span {
    color: #808080;
  }
}

.new_con {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 80px;
  background: #fff;

  h2 {
    color: #082a48;
    //border-bottom: 1px solid #efefef;
    text-align: center;
    padding: 15px 0;
    font-size: 26px;
  }

  .new_con_box {
    font-size: 13px;
    border-bottom: 1px solid #efefef;
    color: #bbb;
    justify-content: space-between;
    margin: 10px 0;
    padding: 0 40px;

    .new_con_left {
      margin-top: 7px;
      margin-bottom: 10px;

      p {
        margin-right: 25px;
      }

      p:nth-last-child(1) {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }
    }

    .new_con_right {
      align-items: center;
      margin-bottom: 10px;

      p {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }

      .new_icon {
        width: 1px;
        height: 10px;
        background: #efefef;
        margin: 0 15px;
      }
    }
  }

  .new_con_mess {
    margin: 35px 0 20px;
    border-bottom: 1px solid #efefef;
    padding: 0 40px;
    padding-bottom: 20px;
    white-space: pre-wrap;

    p {
      margin-bottom: 20px;
      // text-indent: 2em;
      font-size: 15px;
      line-height: 30px;
      // color: #777;
    }

    /deep/ img {
      max-width: 100% !important;
    }

    // .new_img {
    //     text-align: center;

    //     img {
    //         width: 50%;
    //     }
    // }

    /deep/ span {
      font-size: 15px;
      line-height: 30px;
      // color: #777 ;
    }
  }

  .new_bottom {
    position: relative;
    align-content: center;
    font-size: 14px;
    justify-content: space-between;
    padding: 0 40px;
    padding-bottom: 20px;
    height: 40px;
    cursor: pointer;

    .new_bottom_left {
      color: #082a48;

      p:nth-child(1) {
        align-items: center;

        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-right: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        width: 88%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .new_bottom_right {
      color: #082a48;
      text-align: right;

      p:nth-child(1) {
        align-items: center;
        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-left: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        text-align: right;
        position: absolute;
        right: 37px;
        width: 30%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.editorStyleDetailContent {
  /deep/ .video-wrap {
    video {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/park/parkDetails.vue